import { render, staticRenderFns } from "./HelpBot.vue?vue&type=template&id=c493c2d8&scoped=true"
import script from "./HelpBot.vue?vue&type=script&lang=ts"
export * from "./HelpBot.vue?vue&type=script&lang=ts"
import style0 from "./HelpBot.vue?vue&type=style&index=0&id=c493c2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c493c2d8",
  null
  
)

export default component.exports